export const reportConstants = {

    GET_SALES_ORDER_REPORT_REQUEST: "GET_SALES_ORDER_REPORT_REQUEST",
    GET_SALES_ORDER_REPORT_SUCCESS: "GET_SALES_ORDER_REPORT_SUCCESS",
    GET_SALES_ORDER_REPORT_FAILURE: "GET_SALES_ORDER_REPORT_FAILURE",

    GET_DELIVERY_REPORT_REQUEST: "GET_DELIVERY_REPORT_REQUEST",
    GET_DELIVERY_REPORT_SUCCESS: "GET_DELIVERY_REPORT_SUCCESS",
    GET_DELIVERY_REPORT_FAILURE: "GET_DELIVERY_REPORT_FAILURE",


    GET_DELIVERY_REPORT_CONWOOD_REQUEST: "GET_DELIVERY_REPORT_CONWOOD_REQUEST",
    GET_DELIVERY_REPORT_CONWOOD_SUCCESS: "GET_DELIVERY_REPORT_CONWOOD_SUCCESS",
    GET_DELIVERY_REPORT_CONWOOD_FAILURE: "GET_DELIVERY_REPORT_CONWOOD_FAILURE",

    GET_DELIVERY_REPORT_CHILD_REQUEST: "GET_DELIVERY_REPORT_CHILD_REQUEST",
    GET_DELIVERY_REPORT_CHILD_SUCCESS: "GET_DELIVERY_REPORT_CHILD_SUCCESS",
    GET_DELIVERY_REPORT_CHILD_FAILURE: "GET_DELIVERY_REPORT_CHILD_FAILURE",

    GET_TAX_INVOICE_REPORT_REQUEST: "GET_TAX_INVOICE_REPORT_REQUEST",
    GET_TAX_INVOICE_REPORT_SUCCESS: "GET_TAX_INVOICE_REPORT_SUCCESS",
    GET_TAX_INVOICE_REPORT_FAILURE: "GET_TAX_INVOICE_REPORT_FAILURE",

    GET_CREDIT_NOTE_REPORT_REQUEST: "GET_CREDIT_NOTE_REPORT_REQUEST",
    GET_CREDIT_NOTE_REPORT_SUCCESS: "GET_CREDIT_NOTE_REPORT_SUCCESS",
    GET_CREDIT_NOTE_REPORT_FAILURE: "GET_CREDIT_NOTE_REPORT_FAILURE",

    GET_INCENT_PAYMENT_REPORT_REQUEST: "GET_INCENT_PAYMENT_REPORT_REQUEST",
    GET_INCENT_PAYMENT_REPORT_SUCCESS: "GET_INCENT_PAYMENT_REPORT_SUCCESS",
    GET_INCENT_PAYMENT_REPORT_FAILURE: "GET_INCENT_PAYMENT_REPORT_FAILURE",


    

    GET_OPEN_ITEM_REPORT_REQUEST: "GET_OPEN_ITEM_REPORT_REQUEST",
    GET_OPEN_ITEM_REPORT_SUCCESS: "GET_OPEN_ITEM_REPORT_SUCCESS",
    GET_OPEN_ITEM_REPORT_FAILURE: "GET_OPEN_ITEM_REPORT_FAILURE",

    GET_RECEIPT_REPORT_REQUEST: "GET_RECEIPT_REPORT_REQUEST",
    GET_RECEIPT_REPORT_SUCCESS: "GET_RECEIPT_REPORT_SUCCESS",
    GET_RECEIPT_REPORT_FAILURE: "GET_RECEIPT_REPORT_FAILURE",

    GET_INCENTIVE_PAYMENT_REPORT_REQUEST: "GET_INCENTIVE_PAYMENT_REPORT_REQUEST",
    GET_INCENTIVE_PAYMENT_REPORT_SUCCESS: "GET_INCENTIVE_PAYMENT_REPORT_SUCCESS",
    GET_INCENTIVE_PAYMENT_REPORT_FAILURE: "GET_INCENTIVE_PAYMENT_REPORT_FAILURE",

    GET_CUSTOMER_STATEMENT_REPORT_REQUEST: "GET_CUSTOMER_STATEMENT_REPORT_REQUEST",
    GET_CUSTOMER_STATEMENT_REPORT_SUCCESS: "GET_CUSTOMER_STATEMENT_REPORT_SUCCESS",
    GET_CUSTOMER_STATEMENT_REPORT_FAILURE: "GET_CUSTOMER_STATEMENT_REPORT_FAILURE",

    GET_CUSTOMER_STATEMENT_PDF_REPORT_REQUEST: "GET_CUSTOMER_STATEMENT_PDF_REPORT_REQUEST",
    GET_CUSTOMER_STATEMENT_PDF_REPORT_SUCCESS: "GET_CUSTOMER_STATEMENT_PDF_REPORT_SUCCESS",
    GET_CUSTOMER_STATEMENT_PDF_REPORT_FAILURE: "GET_CUSTOMER_STATEMENT_PDF_REPORT_FAILURE",


    GET_CUSTOMER_STATEMENT_REPORT_CONWOOD_REQUEST: "GET_CUSTOMER_STATEMENT_REPORT_CONWOOD_REQUEST",
    GET_CUSTOMER_STATEMENT_REPORT_CONWOOD_SUCCESS: "GET_CUSTOMER_STATEMENT_REPORT_CONWOOD_SUCCESS",
    GET_CUSTOMER_STATEMENT_REPORT_CONWOOD_FAILURE: "GET_CUSTOMER_STATEMENT_REPORT_CONWOOD_FAILURE",

    GET_CUSTOMER_TAX_INVOICE_REPORT_REQUEST: " GET_CUSTOMER_TAX_INVOICE_REPORT_REQUEST",
    GET_CUSTOMER_TAX_INVOICE_REPORT_SUCCESS: " GET_CUSTOMER_TAX_INVOICE_REPORT_SUCCESS",
    GET_CUSTOMER_TAX_INVOICE_REPORT_FAILURE: " GET_CUSTOMER_TAX_INVOICE_REPORT_FAILURE",

    GET_TAX_INVOICE_MATERIAL_REQUEST: " GET_TAX_INVOICE_MATERIAL_REQUEST",
    GET_TAX_INVOICE_MATERIAL_SUCCESS: " GET_TAX_INVOICE_MATERIAL_SUCCESS",
    GET_TAX_INVOICE_MATERIAL_FAILURE: " GET_TAX_INVOICE_MATERIAL_FAILURE",

    GET_TAX_INVOICE_CONTRACTS_REQUEST: " GET_TAX_INVOICE_CONTRACTS_REQUEST",
    GET_TAX_INVOICE_CONTRACTS_SUCCESS: " GET_TAX_INVOICE_CONTRACTS_SUCCESS",
    GET_TAX_INVOICE_CONTRACTS_FAILURE: " GET_TAX_INVOICE_CONTRACTS_FAILURE",
    GET_TAX_INVOICE_CONTRACTS_RESET: " GET_TAX_INVOICE_CONTRACTS_RESET",


    GET_DELIVERY_REPORT_MATERIALMATERIAL_REQUEST: " GET_DELIVERY_REPORT_MATERIALMATERIAL_REQUEST",
    GET_DELIVERY_REPORT_MATERIALMATERIAL_SUCCESS: " GET_DELIVERY_REPORT_MATERIALMATERIAL_SUCCESS",
    GET_DELIVERY_REPORT_MATERIALMATERIAL_FAILURE: " GET_DELIVERY_REPORT_MATERIALMATERIAL_FAILURE",

    GET_DELIVERY_REPORT_SHIPMENT_STATUS_REQUEST: " GET_DELIVERY_REPORT_SHIPMENT_STATUS_REQUEST",
    GET_DELIVERY_REPORT_SHIPMENT_STATUS_SUCCESS: " GET_DELIVERY_REPORT_SHIPMENT_STATUS_SUCCESS",
    GET_DELIVERY_REPORT_SHIPMENT_STATUS_FAILURE: " GET_DELIVERY_REPORT_SHIPMENT_STATUS_FAILURE",


    GET_SALES_REPORT_MATERIALMATERIAL_REQUEST: " GET_SALES_REPORT_MATERIALMATERIAL_REQUEST",
    GET_SALES_REPORT_MATERIALMATERIAL_SUCCESS: " GET_SALES_REPORT_MATERIALMATERIAL_SUCCESS",
    GET_SALES_REPORT_MATERIALMATERIAL_FAILURE: " GET_SALES_REPORT_MATERIALMATERIAL_FAILURE",

    SALES_ORDER_REPORT_EXPORT_REQUEST: "SALES_ORDER_REPORT_EXPORT_REQUEST",
    SALES_ORDER_REPORT_EXPORT_SUCCESS: "SALES_ORDER_REPORT_EXPORT_SUCCESS",
    SALES_ORDER_REPORT_EXPORT_FAILURE: "SALES_ORDER_REPORT_EXPORT_FAILURE",


    DELIVERY_REPORT_EXPORT_REQUEST: "DELIVERY_REPORT_EXPORT_REQUEST",
    DELIVERY_REPORT_EXPORT_SUCCESS: "DELIVERY_REPORT_EXPORT_SUCCESS",
    DELIVERY_REPORT_EXPORT_FAILURE: "DELIVERY_REPORT_EXPORT_FAILURE",


    GET_SALES_AND_DELIVERY_CONTRACTS_REQUEST: " GET_SALES_AND_DELIVERY_CONTRACTS_REQUEST",
    GET_SALES_AND_DELIVERY_CONTRACTS_SUCCESS: " GET_SALES_AND_DELIVERY_CONTRACTS_SUCCESS",
    GET_SALES_AND_DELIVERY_CONTRACTS_FAILURE: " GET_SALES_AND_DELIVERY_CONTRACTS_FAILURE",


    GET_SALES_ORDER_STATUS_REQUEST: "GET_SALES_ORDER_STATUS_REQUEST",
    GET_SALES_ORDER_STATUS_SUCCESS: "GET_SALES_ORDER_STATUS_SUCCESS",
    GET_SALES_ORDER_STATUS_FAILURE: "GET_SALES_ORDER_STATUS_FAILURE",

    GET_SALES_ORDER_SHIPPING_CONDITION_REQUEST: "GET_SALES_ORDER_SHIPPING_CONDITION_REQUEST",
    GET_SALES_ORDER_SHIPPING_CONDITION_SUCCESS: "GET_SALES_ORDER_SHIPPING_CONDITION_SUCCESS",
    GET_SALES_ORDER_SHIPPING_CONDITION_FAILURE: "GET_SALES_ORDER_SHIPPING_CONDITION_FAILURE",

    GET_SALES_ORDER_SHIP_TO_NAME_REQUEST: "GET_SALES_ORDER_SHIP_TO_NAME_REQUEST",
    GET_SALES_ORDER_SHIP_TO_NAME_SUCCESS: "GET_SALES_ORDER_SHIP_TO_NAME_SUCCESS",
    GET_SALES_ORDER_SHIP_TO_NAME_FAILURE: "GET_SALES_ORDER_SHIP_TO_NAME_FAILURE",

    GET_SALES_ORDER_CONTRACT_REQUEST: "GET_SALES_ORDER_CONTRACT_REQUEST",
    GET_SALES_ORDER_CONTRACT_SUCCESS: "GET_SALES_ORDER_CONTRACT_SUCCESS",
    GET_SALES_ORDER_CONTRACT_FAILURE: "GET_SALES_ORDER_CONTRACT_FAILURE",

    GET_SALES_ORDER_MATERIAL_REQUEST: "GET_SALES_ORDER_MATERIAL_REQUEST",
    GET_SALES_ORDER_MATERIAL_SUCCESS: "GET_SALES_ORDER_MATERIAL_SUCCESS",
    GET_SALES_ORDER_MATERIAL_FAILURE: "GET_SALES_ORDER_MATERIAL_FAILURE",






    GET_DELIVERY_STATUS_REQUEST: "GET_DELIVERY_STATUS_REQUEST",
    GET_DELIVERY_STATUS_SUCCESS: "GET_DELIVERY_STATUS_SUCCESS",
    GET_DELIVERY_STATUS_FAILURE: "GET_DELIVERY_STATUS_FAILURE",

    GET_DELIVERY_SHIPPING_CONDITION_REQUEST: "GET_DELIVERY_SHIPPING_CONDITION_REQUEST",
    GET_DELIVERY_SHIPPING_CONDITION_SUCCESS: "GET_DELIVERY_SHIPPING_CONDITION_SUCCESS",
    GET_DELIVERY_SHIPPING_CONDITION_FAILURE: "GET_DELIVERY_SHIPPING_CONDITION_FAILURE",

    GET_DELIVERY_SHIP_TO_NAME_REQUEST: "GET_DELIVERY_SHIP_TO_NAME_REQUEST",
    GET_DELIVERY_SHIP_TO_NAME_SUCCESS: "GET_DELIVERY_SHIP_TO_NAME_SUCCESS",
    GET_DELIVERY_SHIP_TO_NAME_FAILURE: "GET_DELIVERY_SHIP_TO_NAME_FAILURE",

    GET_DELIVERY_CONTRACT_REQUEST: "GET_DELIVERY_CONTRACT_REQUEST",
    GET_DELIVERY_CONTRACT_SUCCESS: "GET_DELIVERY_CONTRACT_SUCCESS",
    GET_DELIVERY_CONTRACT_FAILURE: "GET_DELIVERY_CONTRACT_FAILURE",

    GET_DELIVERY_MATERIAL_REQUEST: "GET_DELIVERY_MATERIAL_REQUEST",
    GET_DELIVERY_MATERIAL_SUCCESS: "GET_DELIVERY_MATERIAL_SUCCESS",
    GET_DELIVERY_MATERIAL_FAILURE: "GET_DELIVERY_MATERIAL_FAILURE",

};
